import { AnimatePresence, motion } from 'framer-motion'

interface BottomSheetProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const BottomSheet = ({ isOpen, onClose, children }: BottomSheetProps) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        key="sheet-backdrop"
        className="fixed inset-0 z-40 bg-black"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.4 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      />
    )}
    {isOpen && (
      <motion.div
        key="sheet-panel"
        className="fixed left-0 right-0 bottom-0 z-50 bg-white rounded-t-[2rem] p-5 pb-8 shadow-2xl"
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ type: 'spring', damping: 32, stiffness: 320 }}
      >
        <div className="mx-auto mb-5 h-1 w-10 rounded-full bg-zinc-200" />
        {children}
      </motion.div>
    )}
  </AnimatePresence>
)

export default BottomSheet
